<div class="contenedor_global">
    <div class="contenedor_cabecera_completa">
        <div class="contenedor_cabecera">
            <div class="cabecera">
                <p>{{"events.title" | translate}}</p>
            </div>
        </div>

        <div class="contenedor_buscador">
            <button id="lupa_button" class="contenedor_lupa" (click)="buscador()" style="cursor:pointer;">
                <mat-icon svgIcon="magnify">
                </mat-icon>
            </button>
            @if (hidden) {
            <input id="barra_busqueda" type="text" [(ngModel)]="searchValue" (input)=filtro_buscador()>
            }
            @if (hidden) {
            <div id="cerrar_busqueda" class="contenedor_cancel">
                <button (click)="buscador()" style="cursor:pointer;">
                    <mat-icon svgIcon="close">
                    </mat-icon>
                </button>
            </div>
            }
        </div>

        <!-- CHAPUZA COCHES ELEGANTES-->
        @if (eventId !== '473afa34-c57c-460f-9de7-8700a2e225c5') {
        <div class="contenedor_filtros_outside">
            <div class="contenedor_filtros_inside" id="contenedor_filtros_inside">
                <button id={{buttons_filter[0].id}} class="button clicked" (click)="activarBoton($event.target)"
                    style="cursor:pointer;">{{buttons_filter[0].contenido}}</button><br>
                <button id={{buttons_filter[1].id}} class="button" (click)="activarBoton($event.target)"
                    style="cursor:pointer;">{{buttons_filter[1].contenido}}</button>
            </div>
        </div>
        } @else {
        <div class="contenedor_filtros_outside">
            <div class="contenedor_filtros_inside" id="contenedor_filtros_inside">
                <button id={{buttons_filter[0].id}} class="button clicked" (click)="getBankTransfers()"
                    style="cursor:pointer;">Pagos pendientes por transferencia bancaria</button><br>
            </div>
        </div>
        }
    </div>

    <div class="contenedor_add_event">

        <div class="add_event" (click)="abrirFormularioPopup()">
            <button class="icono_plus" style="cursor:pointer;">
                <mat-icon svgIcon="plus-grey"></mat-icon>
            </button>
            <p>{{"events.newEvent" | translate}}</p>
        </div>
        @if (data.length === 0 && filteredData.length === 0) {
        <h1 style="color: #545454; position: absolute; top: 50%">
            {{ 'events.noEvents' | translate }}
        </h1>
        }

        @if (!hidden) {
        <ng-container>
            @for (elemento_evento of data; track elemento_evento) {
            <div class="evento_anadido">
                <div class="foto_title" (click)="abrirFormularioEditPopup(elemento_evento)" style="cursor:pointer;">
                    <p>
                        {{elemento_evento.name}}
                    </p>
                </div>
                <div class="stats_evento">
                    <p>{{elemento_evento.ticketsCount}}/{{elemento_evento.amount}}</p>
                    <p>({{(elemento_evento.ticketsCount/elemento_evento.amount)*100 | number:'1.2-2'}}%)</p>
                </div>
                <div class="acciones_evento" (click)="$event.stopPropagation()">
                    <button class="boton_accion" (click)="downloadAttendees(elemento_evento)"
                        [title]="'events.downloadAttendees' | translate" style="cursor:pointer;">
                        <mat-icon svgIcon="file-download"></mat-icon>
                    </button>
                    <button class="boton_accion" (click)="reserveTickets(elemento_evento)"
                        [title]="'events.reserveTickets' | translate" style="cursor:pointer;">
                        <mat-icon svgIcon="full_ticket"></mat-icon>
                    </button>
                </div>

                <div class="precio">
                    <p>{{elemento_evento.price | currency:'EUR'}}</p>
                </div>
            </div>
            }
        </ng-container>
        }
        @if (hidden) {
        <ng-container>
            @for (elemento_evento_filtrado of filteredData; track elemento_evento_filtrado) {
            <div class="evento_anadido">
                <div class="foto_title" (click)="abrirFormularioEditPopup(elemento_evento_filtrado)"
                    style="cursor:pointer;">
                    <mat-icon svgIcon="voucher_use_full"></mat-icon>
                    <p>
                        {{elemento_evento_filtrado.name}}
                    </p>
                </div>
                <div class="acciones_evento" (click)="$event.stopPropagation()">
                    <button class="boton_accion" (click)="downloadAttendees(elemento_evento_filtrado)"
                        [title]="'events.downloadAttendees' | translate" style="cursor:pointer;">
                        <mat-icon svgIcon="download"></mat-icon>
                    </button>
                    <button class="boton_accion" (click)="reserveTickets(elemento_evento_filtrado)"
                        [title]="'events.reserveTickets' | translate" style="cursor:pointer;">
                        <mat-icon svgIcon="ticket"></mat-icon>
                    </button>
                </div>
                <div class="precio">
                    <p>{{elemento_evento_filtrado.price | currency:'EUR'}}</p>
                </div>

            </div>
            }
        </ng-container>
        }

    </div>
</div>

<!-- Fixed Alert at Bottom -->
@if (showAlert) {
<div
    style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); width: 90%; max-width: 600px; z-index: 9999;">
    <bracelit-alert [type]="alertType" (closed)="showAlert = false">
        {{ alertMessage }}
    </bracelit-alert>
</div>
}

<app-footer [activeTab]="'events'"></app-footer>